import { useBrands } from 'src/hooks/useBrands';
import { BrandsContext } from 'src/stores/Brands';
import type { LOCALE_TYPE } from 'src/types/locale';

type Props = {
  locale: LOCALE_TYPE;
  children: React.ReactNode;
};

const BrandsProvider: React.FC<Props> = ({ children }) => {
  const { brands } = useBrands();

  return <BrandsContext.Provider value={brands ?? []}>{children}</BrandsContext.Provider>;
};

export { BrandsProvider };
